import { useEffect } from "react";
import { FaTiktok } from "react-icons/fa";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";
import { FiFacebook } from "react-icons/fi";

const ColaboradorModal = ({ refugio, onClose }) => {

    // const [imageUrls, setImageUrls] = useState([]);
    // const [infoRefugio, setInfoRefugio] = useState(null);

    useEffect(() => {
        // console.log('refugio', refugio);
    }, [refugio]);

    const closeModal = () => {
        // setInfoRefugio(null);
        onClose();
    }

    const stopPropagation = (e) => e.stopPropagation();

    return (
        <div
            id="modalBackground"
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
            onClick={closeModal} // Click outside the modal closes it
        >
            <div
                className="bg-white p-6 rounded-lg shadow-lg relative max-w-lg w-full"
                onClick={stopPropagation} // Prevents clicks inside from closing the modal
            >
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg relative max-w-lg w-full">

                        {/* Close Button */}
                        {/* <button
                            className="absolute top-4 right-4 bg-red-500 text-white px-3 py-1 rounded-full shadow-md hover:bg-red-700 transition"
                            onClick={() => { closeModal(); }}
                        >
                            ✕
                        </button> */}

                        {/* Display Image or Carousel */}
                        <div className="mt-4 w-full h-64 flex justify-center items-center bg-gray-100 rounded">
                            {refugio.urlLogo !== null ? (
                                <img
                                    src={refugio.urlLogo}
                                    alt={refugio.nombre}
                                    className="w-full h-full object-cover rounded"
                                />
                            ) : (
                                <svg
                                    className="w-16 h-16 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M3 7h18M3 12h18m-9 5h9"
                                    />
                                </svg>
                            )}
                        </div>

                        <h2 className="text-xl font-bold text-gray-800">Nombre Refugio: {refugio.nombre}</h2>
                        <p className="text-gray-600">Direccion: {refugio.direccion}</p>
                        <p className="text-gray-600">Numero Referencia: {refugio.numeroReferencia}</p>
                        <p className="text-gray-600">Departamento: {refugio.departamento}</p>

                        <div className="mt-4 flex flex-row justify-between items-center">
                            <div className="flex flex-row gap-4">
                                <a href={refugio.urlFacebook} target="_blank" rel="noopener noreferrer">
                                    <FiFacebook size={24} color="blue" title="Facebook" className="cursor-pointer" />
                                </a>

                                <a href={refugio.urlTikTok} target="_blank" rel="noopener noreferrer">
                                    <FaTiktok size={24} color="black" title="Tiktok" className="cursor-pointer" />
                                </a>
                            </div>

                            <button
                                className="bg-gray-700 text-white px-4 py-2 rounded hover:bg-gray-900 transition"
                                onClick={() => { closeModal(); }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default ColaboradorModal;
